export default __webpack_public_path__ + "static/media/Retro-Computer.ttf.af774aca.woff";